import get from "lodash.get";
import { isEmpty } from "lodash";

import { useDatacomponent } from "../../../../../hooks/useDatacomponent";
import { useUpdateProcessRequests } from "../../../../../hooks/useProcessRequest";
import useActions from "../../../../../hooks/useActions";
import { openModalDialog } from "../../../../../../actions/layoutActions";

export const useProcessSave = (
  dataComponentId,
  formikProps,
  contactPrefix = ""
) => {
  const actions = useActions({
    openModalDialog,
  });

  const onSubmitSuccess = () => {
    const { values } = formikProps;
    const contacts = get(values, "contacts");
    const updatedContacts = contacts.filter(contact => {
      const isUpdated = ["firstName", "lastName", "phoneNumber"].some(key => {
        return (
          get(contact, `${contactPrefix}${key}`) !=
          get(contact, `${contactPrefix}person.${key}`)
        );
      });
      return isUpdated;
    });
    const personIds = updatedContacts.map(contact =>
      get(contact, `${contactPrefix}personId`)
    );
    setTimeout(() => {
      if (!isEmpty(personIds)) {
        actions.openModalDialog("Affected Records", "AffectedRecordsDialog", {
          personId: personIds,
        });
      }
    }, 0);
  };

  const dataComponent = useDatacomponent(dataComponentId);
  useUpdateProcessRequests(dataComponent, {
    onSuccess: onSubmitSuccess,
  });
};
